module.exports = "/_next/static/images/contact-bg-81c78e2dababfee9647e2758e7e91c59.png";